import { ReactElement } from 'react';
import { TranslationMessage } from "components";

import Button from "components/buttons/Button";

interface Props {
    content: {
        [key: string]: any;
    };
    layoutType?: "layout1" | "layout2"
}

function ApplyNowLayout({ content, layoutType }: Props): ReactElement {

    return (


        <section className={`applysection text-center  ${layoutType}`}>
            <h3 className="text-purple font-weight-bold  mb-4 ">
                <TranslationMessage
                    data={content}
                    value="text"
                />
            </h3>
            <div className="d-flex justify-content-center flex-column flex-md-row">
                <div className="mx-2 my-1">
                    <Button
                        buttonStyle="btn-gradient--solid"
                        buttonSize="btn--medium"
                        icon
                        type="button"
                        url={content.button_url}

                    >
                        <TranslationMessage
                            data={content}
                            value="button_text"
                        />
                    </Button>
                </div>
                <div className="mx-2 my-1">

                    <Button
                        buttonStyle="btn-success--outline"
                        buttonSize="btn--medium"
                        icon
                        type="button"
                        url={content.second_button_url}
                    >
                        <TranslationMessage
                            data={content}
                            value="second_button_text"
                        />
                    </Button>
                </div>

            </div>

        </section>

    )
}

export { ApplyNowLayout };
